import lozad from 'lozad';

const observer = lozad('.lazy-load', {
    rootMargin: '50px 0px', // Syntax similar to CSS margin
    threshold: 0.1, // Ratio of element convergence
    enableAutoReload: true, // Reload when attributes change
    loaded: function(el) {
        el.classList.add('loaded'); // Add "loaded" class when element is visible
    }
});

observer.observe();